import { render } from "./NewReviews3Plus.vue?vue&type=template&id=24080882&scoped=true"
import script from "./NewReviews3Plus.vue?vue&type=script&lang=js"
export * from "./NewReviews3Plus.vue?vue&type=script&lang=js"

import "./NewReviews3Plus.vue?vue&type=style&index=0&id=24080882&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24080882"]])

export default __exports__